export function isVideoSearchEnabled(mode: string) {
  return mode === "development" || mode === "test" || mode === "production";
}

export function isVideoAnalysisEnabled(mode: string) {
  return mode === "development" || mode === "test" || mode === "production";
}
